import { SelectedGeolocation } from 'src/app/shared/models/v2/search';
import '../string-prototypes';

export function getCityAndStateSegment(selectedGeolocation: SelectedGeolocation | null): string {
  let cityStateSegment = '';
  if (selectedGeolocation?.city && selectedGeolocation?.state) {
    cityStateSegment = `${
      selectedGeolocation.neighborhood ? selectedGeolocation.neighborhood.toLowerCase().toUrlFriendly() + '-' : ''
    }${selectedGeolocation.city.toLowerCase().toUrlFriendly()}-${selectedGeolocation.state.toLowerCase()}${
      selectedGeolocation.zip ? '-' + selectedGeolocation.zip.toLowerCase() : ''
    }`;
  } else if (selectedGeolocation?.name) {
    cityStateSegment = selectedGeolocation?.name.toLowerCase().replace(/,/g, '').toUrlFriendly();
  }

  return cityStateSegment;
}
